import {setupEngine} from "@helpers/api-helper";

export default {
    async beforeCreate() {
        setupEngine();
    },
};
